import React, { useState } from "react";
// import { useParams } from 'react-router-dom';
import { Box, Button } from "@mui/material";
import MrqSelector from "./components/MrqSelector";
import MrqDetails from "./components/MrqDetails";
import MrqMaterialsTable from "./components/MrqMaterialsTable";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";
import { useMrqContext } from "./MrqContext";
import MrqRegister from "./MrqRegister";
import { useMcsContext } from "../../MCS.context";

export default function Main() {
  const {
    mrqList,
    mrqData,
    mrqSelection,
    setMrqSelection,
    setSelectedMrqData,
    isEditMode,
    setIsEditMode,
    onSubmitEditMrq,
    onChangeDetails,
    onChangeCell,
  } = useMrqContext();
  const { plant } = useMcsContext();
  return (
    <Box sx={{ maxWidth: "1200px" }}>
      <Box sx={{ display: "flex" }}>
        <LabelledBox label="MRQ Register">
          <MrqRegister />
        </LabelledBox>
        <LabelledBox label="MRQ Manager">
          <MrqSelector
            mrqList={mrqList}
            mrqSelection={mrqSelection}
            setMrqSelection={setMrqSelection}
            setSelectedMrqData={setSelectedMrqData}
          />
        </LabelledBox>
      </Box>
      <MrqDetails
        plant={plant}
        mrq={mrqData}
        isEditMode={isEditMode}
        onChangeDetails={onChangeDetails}
      />
      <MrqMaterialsTable
        mrqData={mrqData}
        isEditMode={isEditMode}
        onChangeCell={onChangeCell}
      />
      {isEditMode && (
        <Box sx={{ textAlign: "right" }}>
          <Button
            variant="outlined"
            sx={{ mr: 1 }}
            onClick={() => {
              setIsEditMode(false);
            }}
            color="error"
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={onSubmitEditMrq}>
            Save
          </Button>
        </Box>
      )}
      {/* <AddDataDialog open={dialog.open} onClose={onClose} /> */}
    </Box>
  );
}
